import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../../actions"
import Title from "../../general/title"
import { Redirect } from "react-router-dom"
import submitData from "../../../helpers/submitData"
import * as Yup from "yup"
import { Formik, Field, FieldArray, Form } from "formik"
import fieldStatus from "../../../helpers/fieldStatus"
import Select from "../../../components/Select"
import transformOptionsObject from "../../../helpers/transformOptionsObject"
import trafficFields from "models/traffic"
import ReactSelect from "components/ReactSelect"
import NumberField from "components/NumberField"
import settings from "settings"
import DateField from "components/DateField"
import currentUser from "helpers/currentUser"
import _ from "lodash"

class NewTraffic extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: trafficFields,
			clone: _.cloneDeep(trafficFields.rows[0]),
		}
	}

	reset = () => {
		this.setState({ redirect: true })
	}

	validation = () => {
		const baseFields = {
			property: Yup.number().moreThan(0, "Please choose a community.").required("Required"),
			builder: Yup.string().required("Required"),
			source: Yup.string().notRequired(),
			lot_type: Yup.number().moreThan(0, "Please choose a lot type.").required("Required"),
			email: Yup.string().email("Invalid email address").required(),
			zip: Yup.string().min(5, "Must be 5 characters").max(5, "Must be 5 characters").notRequired(),
			first_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			last_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			is_realtor: Yup.number().required("Required"),
			traffic_date: Yup.number()
				.moreThan(0, "Please enter a date.")
				.required("Required")
				.typeError("Please enter a value."),
		}
		if (settings?.enabled?.sectionsOnTraffic) {
			baseFields.section_id = Yup.number()
				.moreThan(0, "Please choose a section.")
				.required("Required")
				.typeError("Please choose a section.")
		}
		let shape = {
			rows: Yup.array().of(Yup.object().shape(baseFields)),
		}
		if (settings?.customValidation?.groupedTraffic) {
			shape = {
				rows: Yup.array().of(Yup.object().shape(settings.customValidation.groupedTraffic)),
			}
		}
		if (settings?.customValidation?.detailedTraffic) {
			shape = {
				rows: Yup.array().of(Yup.object().shape(settings.customValidation.detailedTraffic)),
			}
		}
		return Yup.object().shape(shape)
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}
	// These can be cleaned up at a later date, no reason for 3 methods here.  Out of time before launch.
	checkNo = (f, index, e, type, field) => {
		let no = settings.noName || "Unknown"
		if (field == "email") {
			no = settings.noEmailAddress
		}
		if (e.target.checked) {
			f.values.rows[index][field] = no
			f.values.rows[index][type] = true
		} else {
			f.values.rows[index][field] = ""
			f.values.rows[index][type] = false
		}
		f.validateForm()
	}

	realtorFields = (f, i) => {
		if (f.values.rows[i].is_realtor == 1) {
			return (
				<>
					<li className={fieldStatus("realtor", f, true, i)}>
						<label htmlFor="realtor">Realtor License Number</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<NumberField
							name="realtor"
							type="text"
							className="form__input"
							onChange={(k, v) => {
								f.setFieldValue(`rows[${i}].realtor`, v)
							}}
							onBlur={f.setFieldTouched}
							touched={f.touched.length > 0 && f.touched.rows[i].realtor}
							error={f.errors.length > 0 && f.errors.rows[i].realtor}
							value={f.values.rows[i].realtor}
						/>
					</li>
				</>
			)
		}
	}

	propertyField = (f, i) => {
		let user = currentUser()
		if (user.builders.length > 1) {
			// more than one property, render properties field
			let options = _.map(user.builders, (v) => {
				let f = _.find(this.props.payload.public.builders, { id: v })
				if (f) {
					return { value: v, label: f.name }
				}
			})
			return (
				<li className={`form__subrow ${fieldStatus("property", f, true, i)}`}>
					<label htmlFor="property">Community</label>
					{f.errors.length > 0 && f.errors.rows[i].property && f.touched.rows[i].property && (
						<div className="form__message">{f.errors.rows[i].property}</div>
					)}
					<Select
						name={`property`}
						options={options}
						className="form__input"
						value={f.values.rows[i].property}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.length > 0 && f.touched.rows[i].property}
						error={f.errors.length > 0 && f.errors.rows[i].property}
						rowIndex={i}
						row={true}
					/>
				</li>
			)
		} else {
			// only one property so manually set
			f.setFieldValue(`rows[${i}].property`, user.builders[0])
		}
		//console.log(user)
	}

	lotTypes = (f, i) => {
		if (!f.values.rows[i].property) {
			return []
		} else {
			let arr = []
			_.forEach(this.props.payload.salespersonPayload.lot_types, (v) => {
				try {
					// Logic to ensure the selected property + builder is only showing the correct lot types
					let propLotTypes = _.find(this.props.payload.public.builders, { id: f.values.rows[i].builder })
					if (!propLotTypes || !propLotTypes?.lot_types?.[f.values.rows[i].property]?.includes(v.value))
						return

					if (v.property == f.values.rows[i].property) {
						arr.push(v)
					}
				} catch (error) {
					console.log(error)
				}
			})
			return arr
		}
	}

	sections = (f, i) => {
		if (!f.values.rows[i].property) {
			return []
		} else {
			let arr = []
			_.forEach(this.props.payload.public.sections, (v) => {
				try {
					if (v.property == f.values.rows[i].property) {
						arr.push({ label: v.name, value: v.id, id: v.id, property: v.property, name: v.name })
					}
				} catch (error) {
					console.log(error)
				}
			})
			return arr
		}
	}

	customFields = (f, index) => {
		if (settings?.detailedTrafficFields) {
			let ret = []
			_.forEach(settings.detailedTrafficFields, (v) => {
				if (v.properties && !v.properties.includes(f.values.rows[index].property)) {
					return
				}
				if (v.type === "select") {
					ret.push(
						<li className={fieldStatus(v.id, f, true, index)}>
							<label htmlFor={v.id}>{v.name}</label>
							<ReactSelect
								name={`rows[${index}].addl.${v.id}`}
								options={v.options}
								value={f.values.rows[index].addl[v.id]}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
								clearable
							/>
						</li>
					)
				}
			})
			return ret
		}
	}

	renderFields = (f, index, arrayHelpers) => {
		let propertyOptions = []
		_.forEach(this.props.payload.salespersonPayload.info.properties, (v) => {
			let b = _.find(this.props.payload.public.properties, { id: v })
			if (b) {
				propertyOptions.push({ value: v, label: b.name })
			}
		})
		let addl = _.get(settings, "additionalTrafficFields") || []
		let states = this.props.payload.public.states
		return (
			<>
				<li className={`form__subrow ${fieldStatus("traffic_date", f, true, index)}`}>
					<label htmlFor="traffic_date">
						Traffic Date <sup>*</sup>
					</label>
					{f.errors.length > 0 && f.errors.rows[index].traffic_date && f.touched.rows[index].traffic_date && (
						<div className="form__message">{f.errors.rows[index].traffic_date}</div>
					)}
					<DateField
						name="traffic_date"
						className="form__textarea"
						value={f.values.rows[index].traffic_date}
						onChange={(k, v) => f.setFieldValue(`rows[${index}].traffic_date`, v)}
						onBlur={() => f.setFieldTouched(`rows[${index}].traffic_date`, true)}
						blockFuture={true}
					/>
				</li>
				<li className={`form__subrow ${fieldStatus("property", f, true, index)}`}>
					<label htmlFor="property">Community *</label>
					{f.errors.length > 0 && f.errors.rows[index].property && f.touched.rows[index].property && (
						<div className="form__message">{f.errors.rows[index].property}</div>
					)}
					<ReactSelect
						name={`rows[${index}].property`}
						options={propertyOptions}
						value={f.values.rows[index].property}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
				<li className={`form__subrow ${fieldStatus("builder", f, true, index)}`}>
					<label htmlFor="builder">
						Builder <sup>*</sup>
					</label>
					{f.errors.length > 0 && f.errors.rows[index].builder && f.touched.rows[index].builder && (
						<div className="form__message">{f.errors.rows[index].builder}</div>
					)}
					<ReactSelect
						name={`rows[${index}].builder`}
						options={transformOptionsObject(this.props.payload.salespersonPayload.builders)}
						value={f.values.rows[index].builder}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
				<li className={`form__subrow ${fieldStatus("lot_type", f, true, index)}`}>
					<label htmlFor="lot_type">
						Lot Type <sup>*</sup>
					</label>
					{f.errors.length > 0 && f.errors.rows[index].lot_type && f.touched.rows[index].lot_type && (
						<div className="form__message">{f.errors.rows[index].lot_type}</div>
					)}
					<ReactSelect
						name={`rows[${index}].lot_type`}
						options={this.lotTypes(f, index)}
						value={f.values.rows[index].lot_type}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
				<li className={`form__subrow ${fieldStatus("source", f, true, index)}`}>
					<label htmlFor="source">
						Traffic Source{settings?.requireSourceOnDetailedTraffic ? <sup>*</sup> : null}
					</label>
					{f.errors.length > 0 && f.errors.rows[index].source && f.touched.rows[index].source && (
						<div className="form__message">{f.errors.rows[index].source}</div>
					)}
					<ReactSelect
						name={`rows[${index}].source`}
						options={transformOptionsObject(this.props.payload.public.trafficSources)}
						value={f.values.rows[index].source}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
						clearable
					/>
				</li>
				{settings?.enabled?.trafficSourceDetails ? (
					<li className={fieldStatus("source_details", f, true, index)}>
						<label htmlFor="source_details">Source Detail</label>
						{f.errors.length > 0 &&
							f.errors.rows[index].source_details &&
							f.touched.rows[index].source_details && (
								<div className="form__message">{f.errors.rows[index].source_details}</div>
							)}
						<Field
							onBlur={() => f.setFieldTouched(`rows[${index}].source_details`, true)}
							name={`rows.${index}.source_details`}
							type="text"
							className="form__input"
						/>
					</li>
				) : null}
				{settings?.enabled?.sectionsOnTraffic ? (
					<li className={`form__subrow ${fieldStatus("section_id", f, true, index)}`}>
						<label htmlFor="section">Section</label>
						{f.errors.length > 0 && f.errors.rows[index].section_id && f.touched.rows[index].section_id && (
							<div className="form__message">{f.errors.rows[index].section_id}</div>
						)}
						<ReactSelect
							name={`rows[${index}].section_id`}
							options={this.sections(f, index)}
							value={f.values.rows[index].section_id}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				) : null}
				<li className={fieldStatus("first_name", f, true, index)}>
					<label htmlFor="first_name">
						First Name <sup>*</sup>
					</label>
					<div className="noEmail">
						<Field
							type="checkbox"
							name={`rows[${index}].no_first`}
							onChange={(e) => this.checkNo(f, index, e, "no_first", "first_name")}
						/>
						No First Name
					</div>
					{f.errors.length > 0 && f.errors.rows[index].first_name && f.touched.rows[index].first_name && (
						<div className="form__message">{f.errors.rows[index].first_name}</div>
					)}
					<Field
						onBlur={() => f.setFieldTouched(`rows[${index}].first_name`, true)}
						name={`rows.${index}.first_name`}
						type="text"
						className="form__input"
					/>
				</li>
				<li className={fieldStatus("last_name", f, true, index)}>
					<label htmlFor="last_name">
						Last Name <sup>*</sup>
					</label>
					<div className="noEmail">
						<Field
							type="checkbox"
							name={`rows[${index}].no_last`}
							onChange={(e) => this.checkNo(f, index, e, "no_last", "last_name")}
						/>
						No Last Name
					</div>
					{f.errors.length > 0 && f.errors.rows[index].last_name && f.touched.rows[index].last_name && (
						<div className="form__message">{f.errors.rows[index].last_name}</div>
					)}
					<Field
						onBlur={() => f.setFieldTouched(`rows[${index}].last_name`, true)}
						name={`rows.${index}.last_name`}
						type="text"
						className="form__input"
					/>
				</li>
				<li className={fieldStatus("zip", f, true, index)}>
					<label htmlFor="zip">Zip{settings?.requireZipOnDetailedTraffic ? <sup>*</sup> : null}</label>
					{f.errors.length > 0 && f.errors.rows[index].zip && f.touched.rows[index].zip && (
						<div className="form__message">{f.errors.rows[index].zip}</div>
					)}
					<Field name={`rows.${index}.zip`} type="text" className="form__input" />
				</li>
				<li className={fieldStatus("email", f, true, index)}>
					<label htmlFor="email">
						Email <sup>*</sup>
					</label>
					<div className="noEmail">
						<Field
							type="checkbox"
							name={`rows[${index}].no_email`}
							onChange={(e) => this.checkNo(f, index, e, "no_email", "email")}
						/>
						No Email
					</div>
					{f.errors.length > 0 && f.errors.rows[index].email && f.touched.rows[index].email && (
						<div className="form__message">{f.errors.rows[index].email}</div>
					)}
					<Field name={`rows.${index}.email`} type="email" className="form__input" />
				</li>
				<li className="form__subItemRemove">
					<i className="fa fa-minus-circle" onClick={() => arrayHelpers.remove(index)} />
				</li>
				<li className={`form__subrow ${fieldStatus("is_realtor", f, true, index)}`}>
					<label htmlFor="is_realtor">
						Is this person a Realtor? <sup>*</sup>
					</label>
					{f.errors.length > 0 && f.errors.rows[index].is_realtor && f.touched.rows[index].is_realtor && (
						<div className="form__message">{f.errors.rows[index].is_realtor}</div>
					)}
					<ReactSelect
						name={`rows[${index}].is_realtor`}
						options={[
							{ value: 0, label: "No" },
							{ value: 1, label: "Yes" },
						]}
						value={f.values.rows[index].is_realtor}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
				{_.find(addl, { type: "street" }) ? (
					<li className={fieldStatus("street", f, true, index)}>
						<label htmlFor="street">Address</label>
						{f.errors.length > 0 && f.errors.rows[index].street && f.touched.rows[index].street && (
							<div className="form__message">{f.errors.rows[index].street}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`rows[${index}].street`, true)}
							name={`rows.${index}.street`}
							type="text"
							className="form__input"
						/>
					</li>
				) : null}
				{_.find(addl, { type: "city" }) ? (
					<li className={fieldStatus("city", f, true, index)}>
						<label htmlFor="city">City</label>
						{f.errors.length > 0 && f.errors.rows[index].city && f.touched.rows[index].city && (
							<div className="form__message">{f.errors.rows[index].city}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`rows[${index}].city`, true)}
							name={`rows.${index}.city`}
							type="text"
							className="form__input"
						/>
					</li>
				) : null}
				{_.find(addl, { type: "state" }) ? (
					<li className={fieldStatus("state", f, true, index)}>
						<label htmlFor="state">State</label>
						{f.errors.length > 0 && f.errors.rows[index].state && f.touched.rows[index].state && (
							<div className="form__message">{f.errors.rows[index].state}</div>
						)}
						<ReactSelect
							name={`rows[${index}].state`}
							options={states}
							value={f.values.rows[index].state}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
				) : null}
				{_.find(addl, { type: "zip" }) ? (
					<li className={fieldStatus("zip", f, true, index)}>
						<label htmlFor="zip">Zip</label>
						{f.errors.length > 0 && f.errors.rows[index].zip && f.touched.rows[index].zip && (
							<div className="form__message">{f.errors.rows[index].zip}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`rows[${index}].zip`, true)}
							name={`rows.${index}.zip`}
							type="text"
							className="form__input"
						/>
					</li>
				) : null}
				{_.find(addl, { type: "how_much" }) ? (
					<li className={fieldStatus("how_much", f, true, index)}>
						<label htmlFor="how_much">Price Range</label>
						{f.errors.length > 0 && f.errors.rows[index].how_much && f.touched.rows[index].how_much && (
							<div className="form__message">{f.errors.rows[index].how_much}</div>
						)}
						<ReactSelect
							name={`rows[${index}].how_much`}
							options={_.find(addl, { type: "how_much" }).options.map((v) => {
								return { value: v, label: v }
							})}
							value={f.values.rows[index].how_much}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
				) : null}
				{_.find(addl, { type: "timeframe" }) ? (
					<li className={fieldStatus("timeframe", f, true, index)}>
						<label htmlFor="timeframe">Timeframe</label>
						{f.errors.length > 0 && f.errors.rows[index].timeframe && f.touched.rows[index].timeframe && (
							<div className="form__message">{f.errors.rows[index].timeframe}</div>
						)}
						<ReactSelect
							name={`rows[${index}].timeframe`}
							options={_.find(addl, { type: "timeframe" }).options.map((v) => {
								return { value: v, label: v }
							})}
							value={f.values.rows[index].timeframe}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
				) : null}
				{_.find(addl, { type: "want_text" }) ? (
					<li className={fieldStatus("want_text", f, true, index)}>
						<label htmlFor="want_text">Subscribe To Text?</label>
						{f.errors.length > 0 && f.errors.rows[index].want_text && f.touched.rows[index].want_text && (
							<div className="form__message">{f.errors.rows[index].want_text}</div>
						)}
						<ReactSelect
							name={`rows[${index}].want_text`}
							options={_.find(addl, { type: "want_text" }).options.map((v) => {
								return { value: v.value, label: v.label }
							})}
							value={f.values.rows[index].want_text}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
				) : null}
				{this.customFields(f, index)}
			</>
		)
	}

	renderform = (f) => {
		return (
			<div className="content">
				<Form>
					<FieldArray
						name="rows"
						render={(arrayHelpers) => (
							<div>
								<p className="traffic__addMore">
									<span
										onClick={() => {
											//console.log(trafficFields)
											return arrayHelpers.insert(0, this.state.clone)
										}}>
										<i className="fa fa-plus-circle" />
										Add Another Traffic Row
									</span>
								</p>
								<ul>
									{f.values.rows && f.values.rows.length > 0
										? f.values.rows.map((row, index) => (
												<li key={index}>
													<ul className="form__subList">
														{this.renderFields(f, index, arrayHelpers)}
														{this.realtorFields(f, index)}
													</ul>
												</li>
										  ))
										: ""}
								</ul>
							</div>
						)}
					/>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else if (this.props.payloadStatus) {
			return (
				<div>
					<Formik
						initialValues={this.state.fields}
						validationSchema={this.validation}
						validateOnMount={true}
						onSubmit={(values) => {
							//this.props.loadingStatus(true)
							//console.log(values)
							//return
							submitData("inputTraffic", values).then((data) => {
								//return
								this.props.loadingStatus(false)
								this.setState(
									{
										redirect: true,
										redirectPath: data.redirect,
									},
									() => {
										this.props.getPayload()
									}
								)
							})
						}}
						render={(f) => (
							<div>
								{/* console.log(f) */}
								<Title title="Add Traffic" showDate={false} />
								{this.renderform(f)}
							</div>
						)}
					/>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(NewTraffic)
